import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import Button, { BUTTON_TYPE } from '../../../../../components/Button';
import { SHIFT_TIME_ALERT_TYPES } from '../../../constDicts';
import ShiftTimeAlert from '../CustomComponents/ShiftTimeAlert';

const ConfirmModalFooter = ({
  hasInvalidShiftDuration,
  isProcessing,
  canPost,
  onClose,
  onPost,
  translate,
  sx,
}) => (
  <>
    {hasInvalidShiftDuration && (
      <Box sx={{ mb: 2 }}>
        <ShiftTimeAlert alertType={SHIFT_TIME_ALERT_TYPES.MAX} />
      </Box>
    )}

    <Box sx={sx.footerActions}>
      <Button text={translate('button.edit')} onClick={onClose} sx={sx.editButton} />
      <Button
        data-testid="modalSubmitButton"
        type={BUTTON_TYPE.BUTTON}
        text={translate('job.create.post')}
        disabled={isProcessing || !canPost}
        onClick={onPost}
        sx={sx.postButton}
      />
    </Box>
  </>
);

ConfirmModalFooter.propTypes = {
  canPost: PropTypes.bool,
  hasInvalidShiftDuration: PropTypes.bool,
  isProcessing: PropTypes.bool,
  onClose: PropTypes.func,
  onPost: PropTypes.func,
  sx: PropTypes.shape({
    footerActions: PropTypes.shape({}).isRequired,
    editButton: PropTypes.shape({}).isRequired,
    postButton: PropTypes.shape({}).isRequired,
  }).isRequired,
  translate: PropTypes.func.isRequired,
};

export default ConfirmModalFooter;
